$(function () {
    if ($('#lineChart').length) {

        var lineChart;
        var year = $('[data-for="year"]');
        var month = $('[data-for="month"]');
        var site = $('[data-for="site"]');

        var renderChart = function( labels, successOrders, failedOrders )
        {
            var ctx = document.getElementById("lineChart");
            lineChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: "Success Orders",
                            backgroundColor: "#2ecc71",
                            borderColor: "#27ae60",
                            borderDash: [5, 5],
                            pointBorderColor: "rgba(22, 59, 108, 0.7)",
                            pointBackgroundColor: "rgba(22, 59, 108, 0.7)",
                            pointHoverBackgroundColor: "#fff",
                            pointHoverBorderColor: "rgba(22, 59, 108, 0.7)",
                            pointBorderWidth: 0,
                            data: successOrders
                        },
                        {
                            label: "Failed Orders",
                            backgroundColor: "#e74c3c",
                            borderColor: "#c0392b",
                            pointBorderColor: "rgba(178, 143, 196, 0.7)",
                            pointBackgroundColor: "rgba(178, 143, 196, 0.7)",
                            pointHoverBackgroundColor: "#fff",
                            pointHoverBorderColor: "rgba(178, 143, 196, 0.7)",
                            pointBorderWidth: 0,
                            data: failedOrders
                        }
                    ]
                }
            });
        };

        var fetchData = function()
        {
            $.get( window.dashboardUrls[ 'get.cards.sales' ], { year : year.val(), month : month.val(), site : site.val() }, function( response ) {
                var labels = [];
                var successOrders = [];
                var failedOrders = [];
                response.labels.forEach( function( item ) {
                    labels.push( item.label );
                    successOrders.push( item.success_orders );
                    failedOrders.push( item.failes_orders );
                });
                if( lineChart ) {
                    lineChart.destroy();
                    lineChart = null;
                }
                renderChart( labels, successOrders, failedOrders );
            });
        };


        [ month, year, site ].forEach( function( elm ) {
            elm.on( 'change', function(e) {
                e.preventDefault();
                fetchData();
            });
        });

        fetchData();

    }
});
